/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { ClaimType } from '@constants';
import { SliceName } from '../constants';

export const claimSlice = createSlice({
  name: SliceName.Claim,
  initialState: {
    type: ClaimType.Init,
    files: [],
    delayPackageId: '',
    selectedItems: [],
    orderName: '',
    packageList: [],
    unfulfilledItemList: [],
    policyId: '',
    // new
    fulfilledItems: [],
    unFulfilledItems: [],
    paymentMethod: {}, // store payment method
    // paymentInfo: {}, // store payment card
    // returnMethod: {}, // store return method
    reviewData: {},
    supportedPaymentMethod: [], // supported payment Method for the issue
    orderNumber: '',
  },
  reducers: {
    setPackageList(state, { payload }) {
      if (!payload) {
        return;
      }
      const {
        orderName = '',
        fulfilledItems = [],
        unFulfilledItems = [], returnCoverageDay,
      } = payload;
      state.fulfilledItems = fulfilledItems;
      state.orderName = orderName;
      state.returnCoverageDay = returnCoverageDay;
      const unFulfilledList = [];
      unFulfilledItems.forEach((item) => {
        item.items.forEach((v) => unFulfilledList.push(v));
      });
      state.unFulfilledItems = unFulfilledList;
    },
    setClaimInfo(state, { payload }) {
      state.type = payload.type;
      state.policyId = payload.policyId;
      state.supportedPaymentMethod = payload.supportedPaymentMethod;
      state.orderNumber = payload.orderNumber;
    },
    setUploadChosen(state, { payload }) {
      state.files = payload.files;
      state.comments = payload.comments;
    },
    setDelayPackageId(state, { payload }) {
      state.delayPackageId = payload;
    },
    addSelectedItems(state, { payload }) {
      const { selectedItems } = state;
      const index = selectedItems.findIndex((item) => item === payload);
      if (index > -1) {
        return;
      }
      selectedItems.push(payload);
    },
    deleteSelectedItems(state, { payload }) {
      const { selectedItems } = state;
      const index = selectedItems.findIndex((item) => item === payload);
      if (index === -1) {
        return;
      }
      selectedItems.splice(index, 1);
    },
    clearSelectedItems(state) {
      state.selectedItems = [];
      state.selectedData = {};
    },
    // RA 添加原因
    addPackageReason(state, { payload }) {
      const { willChecked: { packageIndex, lineIndex }, reason } = payload;
      state.fulfilledItems[packageIndex].items[lineIndex].reason = reason.type;
      state.fulfilledItems[packageIndex].items[lineIndex].comment = reason.comments?.trim();
      state.fulfilledItems[packageIndex].items[lineIndex].attachments = reason.files;
    },
    /**
 * @param {Object} selectedData review入参，保存后让提交接口取用
 * @param {Array} selectedPackageList review页面渲染用
 */
    setSelectedData(state, { payload }) {
      state.selectedData = payload.body;
      state.selectedPackageList = payload.selectedPackageList;
    },
    setPaymentMethod(state, { payload }) {
      if (!payload) {
        return;
      }
      state.paymentMethod = payload;
    },
    // setPaymentInfo(state, { payload }) {
    //   if (!payload) {
    //     return;
    //   }
    //   state.paymentInfo = payload;
    // },
    // setReturnMethod(state, { payload }) {
    //   if (!payload) {
    //     return;
    //   }
    //   state.returnMethod = payload;
    // },
    setReviewInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      state.reviewData = payload;
    },
  },
});

export const {
  setPackageList,
  setClaimInfo,
  setUploadChosen,
  setDelayPackageId,
  addSelectedItems,
  deleteSelectedItems,
  clearSelectedItems,
  addPackageReason,
  setSelectedData,
  setPaymentMethod,
  // setPaymentInfo,
  // setReturnMethod,
  setReviewInfo,
} = claimSlice.actions;

export default claimSlice.reducer;
